<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="medium"
      inline-message
    >
      <div class="d-flex">
        <div class="side-frame-success"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            File name：{{ formData.fileName ? formData.fileName : '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <b-badge
            style="font-size: 12px"
            :variant="
              formData.fileStatus === 'Y'
                ? 'primary'
                : formData.fileStatus === 'N'
                ? 'warning'
                : 'success'
            "
          >
            {{ formData.v_fileStatus }}
          </b-badge>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            Upload：{{ formData.uploadByName ? formData.uploadByName : '--' }}
            at
            {{ formData.uploadTime ? formData.uploadTime : '--' }}
          </span>
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_docFileType') || '文档类型'"
            prop="docFileType"
          >
            <dict-select
              v-model="formData.docFileType"
              url="/master/common/dict/biz"
              :placeholder="$l('INDEX.tips_select_data') || '请选择'"
              style="width: 100%"
              filterable
              clearable
              size="mini"
              :body="docFileTypeParams"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('INDEX.table_label_remarks') || '备注说明'">
            <el-input
              v-model="formData.docRemark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="mini"
              clearable
              maxlength="500"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tripReimbursementReportDocCode: {type: String, default: ''},
  },
  data() {
    return {
      docFileTypeParams: {dictType: 'docFileType'},
      formData: {},
      rules: {
        docFileType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.tripReimbursementReportDocCode) return
      this.$api
        .userTripReimbursementReportDocDetailApi({
          tripReimbursementReportDocCode: this.tripReimbursementReportDocCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()

      const params = {
        ...this.formData,
      }

      this.$api
        .userTripReimbursementReportDocUpdateApi(params)
        .then((res) => {
          this.loadingClose()
          const {status} = res
          if (status !== 200) {
            this.$message.error(this.$l('table_Upload_failed') || '上传失败')
            return
          }
          this.$message({
            showClose: true,
            message:
              this.$l('INDEX.uploader_message_status_success') || '上传成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
